import { Injectable } from '@angular/core';
import { PortalTypeEnum } from '@ats/api/cm';
import { SettingsService } from '@cm/core/settings';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { CmCulture, PortalCoreFeature } from '../models';

/**
 * @deprecated Use @cm/core/settings SettingsService
 */
@Injectable({
	providedIn: 'root',
})
export class CmSettingsService {
	client$: Observable<string>;

	/**
	 * @deprecated Use @cm/core/settings SettingsService.clientSnapshot
	 */
	get client(): string {
		return this.settings.clientSnapshot;
	}

	/**
	 * @deprecated Use @cm/core/settings SettingsService.culture$
	 */
	culture$: Observable<CmCulture> = this.settings.culture$.pipe(map(culture => <CmCulture>culture));

	/**
	 * @deprecated Use @cm/core/settings SettingsService.existingCultures$
	 */
	clientCultures$: Observable<CmCulture[]> = this.settings.existingCultures$;

	/**
	 * @deprecated Use @cm/core/settings SettingsService.supportedCultures$
	 */
	supportedCultures$: Observable<CmCulture[]> = this.settings.supportedCultures$;

	/**
	 * @deprecated Use @cm/core/settings SettingsService.apiWithContext$
	 */
	apiWithContext$: Observable<string> = this.settings.apiWithContext$;

	/**
	 * @deprecated Use @cm/core/settings SettingsService.spUrl
	 */
	readonly spUrl: string = this.settings.spUrl;
	/**
	 * @deprecated Use @cm/core/settings SettingsService.cpUrl
	 */
	readonly cpUrl: string = this.settings.cpUrl;
	/**
	 * @deprecated Use @cm/core/settings SettingsService.api
	 */
	readonly api: string = this.settings.api;
	/**
	 * @deprecated Use @cm/core/settings SettingsService.portalNumeric
	 */
	readonly portal: PortalTypeEnum = this.settings.portalNumeric;
	/**
	 * @deprecated Use @cm/core/settings SettingsService.coreFeature
	 */
	readonly portalCoreFeature: PortalCoreFeature = this.settings.coreFeature;

	/**
	 * @deprecated Use @cm/core/settings SettingsService.culture$
	 */
	language$: Observable<string> = this.settings.culture$.pipe(map(culture => culture.code));

	/**
	 * @deprecated Use @cm/core/settings SettingsService.client/client$ and/or SettingsService.culture$
	 */
	settings$: Observable<{ client: string; language: string }> = combineLatest([
		this.settings.client$,
		this.language$,
	]).pipe(map(([client, language]) => ({ client, language })));

	constructor(private readonly settings: SettingsService) {
		this.client$ = this.settings.client$;
	}

	/**
	 * @deprecated Use @cm/core/settings SettingsService.routeWithContext
	 */
	route(path: string[]): string[] {
		return this.settings.routeWithContext(path);
	}

	/**
	 * @deprecated Use @cm/core/settings SettingsService.routeWithNewCulture
	 */
	routeWithNewCulture(path: string[], newCulture: string) {
		return this.settings.routeWithNewCulture(path, newCulture);
	}
}
